import ListItem from "./List";
import ObjectItem from "./Object";
import PropertyItem from "./Property";
import LabelPropertyItem from "./LabelProperty";
import ValuePropertyItem from "./ValueProperty";
import OptionObjectItem from "./OptionObject";
import OptionListItem from "./OptionList";

import { TYPE_LIST, TYPE_OBJECT, TYPE_PROPERTY, TYPE_LABEL, TYPE_VALUE, TYPE_OPTION, TYPE_OPTION_LIST } from './types'

export default {
  [TYPE_LIST]: ListItem,
  [TYPE_OBJECT]: ObjectItem,
  [TYPE_PROPERTY]: PropertyItem,
  [TYPE_LABEL]: LabelPropertyItem,
  [TYPE_VALUE]: ValuePropertyItem,
  [TYPE_OPTION]: OptionObjectItem,
  [TYPE_OPTION_LIST]: OptionListItem,
}